import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=6a064122&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a064122')) {
      api.createRecord('6a064122', component.options)
    } else {
      api.reload('6a064122', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=6a064122&", function () {
      api.rerender('6a064122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FAQ.vue"
export default component.exports